// Each provider exposes an explicit set of business fields. Never render raw record keys.
const coreColumns = [
  { title: "ID", key: "id", dataIndex: "id", width: 100, fixed: "left" },
  { title: "用户ID", key: "userId", dataIndex: "userId", width: 110 },
  { title: "用户注册时间", key: "userCreateTime", dataIndex: "userCreateTime", width: 175 },
  { title: "记录创建时间", key: "createTime", dataIndex: "createTime", width: 175 },
  { title: "签约状态", key: "status", dataIndex: "status", width: 160 },
  { title: "已签约", key: "isAgreement", dataIndex: "isAgreement", width: 90, boolean: true },
];
const deductionColumns = [
  { title: "首次金额（元）", key: "firstDeductionAmount", dataIndex: "firstDeductionAmount", width: 180, align: "right", amount: true },
  { title: "下次金额（元）", key: "nextDeductionAmount", dataIndex: "nextDeductionAmount", width: 180, align: "right", amount: true },
  { title: "下次扣款时间", key: "nextDeductionDate", dataIndex: "nextDeductionDate", width: 175 },
  { title: "成功扣款次数", key: "paidCount", dataIndex: "paidCount", width: 120, align: "right" },
];
const relatedFields = [
  { key: "goodId", label: "商品ID" },
  { key: "goodName", label: "商品名称" },
  { key: "merchantId", label: "商户ID" },
  { key: "merchantName", label: "商户名称" },
];
const bankColumns = [
  ...coreColumns,
  { title: "已支付", key: "isPay", dataIndex: "isPay", width: 90, boolean: true },
  { title: "渠道", key: "channel", dataIndex: "channel", width: 140 },
  ...deductionColumns,
  { title: "本周期失败次数", key: "failedAttempts", dataIndex: "failedAttempts", width: 130, align: "right" },
];
const bankDetailFields = [
  ...relatedFields,
  { key: "title", label: "标题" },
  { key: "bankCode", label: "银行编码" },
  { key: "cardType", label: "卡类型" },
  { key: "firstDeductionDate", label: "首次扣款时间" },
  { key: "tag", label: "标签" },
  { key: "tradeType", label: "交易类型" },
  { key: "cancelTime", label: "解约时间" },
  { key: "isRetryOrder", label: "回捞订单", boolean: true },
  { key: "retryGoodsList", label: "回捞重试商品ID" },
  { key: "xRequestedWith", label: "来源包名" },
  { key: "lastAttemptAt", label: "上次尝试时间" },
  { key: "nextRetryDate", label: "下次重试时间" },
  { key: "asset", label: "资产ID" },
  { key: "createDate", label: "记录创建日期" },
  { key: "updateTime", label: "记录修改时间" },
];

export const agreementProviders = {
  airwallex: {
    title: "空中云汇",
    statsPath: "/order/stats/daily/airwallex-agreement",
    listPath: "/order/airwallex-agreement/list",
    amountNote: "金额以元显示，保留两位小数并标明币种。",
    columns: [
      ...coreColumns,
      { title: "签约方式", key: "mode", dataIndex: "mode", width: 120 },
      { title: "支付环境", key: "environment", dataIndex: "environment", width: 100 },
      { title: "币种", key: "currency", dataIndex: "currency", width: 80 },
      ...deductionColumns,
    ],
    detailFields: [
      ...relatedFields,
      { key: "customerId", label: "空中云汇客户ID" },
      { key: "requestId", label: "签约请求幂等号" },
      { key: "firstDeductionDate", label: "首次扣款时间" },
      { key: "firstPeriodDays", label: "首期天数" },
      { key: "nextPeriodDays", label: "续期天数" },
      { key: "agreedAt", label: "用户授权时间" },
      { key: "termsVersion", label: "授权条款版本" },
      { key: "cancelRequested", label: "已申请解约", boolean: true },
      { key: "cancelTime", label: "解约时间" },
      { key: "createDate", label: "记录创建日期" },
      { key: "updateTime", label: "记录修改时间" },
      { key: "returnUrl", label: "支付返回地址", wide: true },
      { key: "websiteUrl", label: "签约交易网站", wide: true },
      { key: "metaAttribution", label: "Meta下单归因快照", wide: true },
    ],
  },
  hlb: {
    title: "合利宝",
    statsPath: "/order/stats/daily/hlb-agreement",
    listPath: "/order/hlb-agreement/list",
    amountNote: "金额由人民币分折算为人民币元，保留两位小数。",
    columns: bankColumns,
    detailFields: bankDetailFields,
  },
  kq: {
    title: "快钱",
    statsPath: "/order/stats/daily/kq-agreement",
    listPath: "/order/kq-agreement/list",
    amountNote: "金额由人民币分折算为人民币元，保留两位小数。",
    columns: bankColumns,
    detailFields: bankDetailFields,
  },
};
